module.exports = __webpack_public_path__ + "media/images/pc/stores/nagoya_ekimae/nagoya_ekimae_concept_02-2d19c1be4f1e0fd39bd26119b58172f4.jpg";